
// import React from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
// import ExamInstructions from "./ExamInstructions";
// import ExamQuestion from "./ExamQuestion";
// import EndTest from "./EndTest";
// import StudentProfile from "./StudentProfile";
// import Navbar from "./Components/Navbar";
// import LoginPage from "./LoginPage";
// import TestReview from "./TestReview";
// import ScrollToTop from "./Components/scrolltotop";
// import './App.css'
// import PrivateRoute from "./PrivateRoute.jsx";
// const AppContent = () => {
//   const location = useLocation();

//   // Hide navbar for specific routes
//   const hideNavbarRoutes = ["/login", "/"]; 
//   const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

//   return (
//     <>
//       <ScrollToTop />
//       {!shouldHideNavbar && <Navbar />}

//       <Routes caseSensitive={false}>
//         {/* Redirect root to /login */}
//         <Route path="/" element={<Navigate to="/login" replace />} />

//         {/* Login page */}
//         <Route path="/login" element={<LoginPage />} />

//         {/* Profile */}
//         <Route path="/profile" element={<StudentProfile />} />

//         {/* Exam Instructions */}
//         <Route path="/ExamInstruction/:attemptId" element={<ExamInstructions />} />

//         {/* Exam Questions */}
//         <Route path="/ExamQuestion/:attemptId" element={<ExamQuestion />} />

//         {/* End Test */}
//         <Route path="/EndTest" element={<EndTest />} />

//         {/* Test Review */}
//         <Route path="/test-review/:attemptId" element={<TestReview />} />

//         {/* Catch all unmatched routes */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </>
//   );
// };

// const App = () => {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// };

// export default App;


// import React from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import ExamInstructions from "./ExamInstructions";
// import ExamQuestion from "./ExamQuestion";
// import EndTest from "./EndTest";
// import StudentProfile from "./StudentProfile";
// import Navbar from "./Components/Navbar";
// import LoginPage from "./LoginPage";
// import TestReview from "./TestReview";
// import ScrollToTop from "./Components/scrolltotop";
// import './App.css'

// const AppContent = () => {
//   const location = useLocation();

//   const hideNavbarRoutes = ["/"]; // You can add more paths here to hide navbar on multiple pages

//   const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

//   return (
//     <>
//       <ScrollToTop />
//       {!shouldHideNavbar && <Navbar />}

//       <Routes caseSensitive={false}>
//         <Route path="/" element={<LoginPage />} />
//         <Route path="/profile" element={<StudentProfile />} />
//         {/* <Route path="/ExamInstruction" element={<ExamInstructions />} /> */}
//         <Route path="/ExamInstruction/:attemptId" element={<ExamInstructions />} />
//         {/* <Route path="/ExamInstruction/link/:examLink" element={<ExamInstructions />} />
//         <Route path="/ExamInstruction/id/:paperId" element={<ExamInstructions />} /> */}
//         {/* <Route path="/ExamQuestion" element={<ExamQuestion />} /> */}
//         <Route path="/ExamQuestion/:attemptId" element={<ExamQuestion />} />
//         <Route path="/EndTest" element={<EndTest />} />
//         <Route path="/test-review/:attemptId" element={<TestReview />} />
//      </Routes>
//     </>
//   );
// };

// const App = () => {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// };

// export default App;






// import React from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import ExamInstructions from "./ExamInstructions";
// import ExamQuestion from "./ExamQuestion";
// import EndTest from "./EndTest";
// import StudentProfile from "./StudentProfile";
// import Navbar from "./Components/Navbar";
// import LoginPage from "./LoginPage";
// import TestReview from "./TestReview";
// import ScrollToTop from "./Components/scrolltotop";
// import ProtectedRoute from "./Components/ProtectedRoute";
// import './App.css';

// const AppContent = () => {
//   const location = useLocation();
//   const hideNavbarRoutes = ["/"];
//   const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

//   return (
//     <>
//       <ScrollToTop />
//       {!shouldHideNavbar && <Navbar />}

//       <Routes>
//         <Route path="/" element={<LoginPage />} />

//         <Route
//           path="/profile"
//           element={
//             <ProtectedRoute>
//               <StudentProfile />
//             </ProtectedRoute>
//           }
//         />
//         <Route path="/ExamInstruction/:attemptId" element={<ExamInstructions />} />
//         <Route
//           path="/ExamQuestion/:attemptId"
//           element={
//             <ProtectedRoute>
//               <ExamQuestion />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/EndTest"
//           element={
//             <ProtectedRoute>
//               <EndTest />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/TestReview"
//           element={
//             <ProtectedRoute>
//               <TestReview />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>
//     </>
//   );
// };

// const App = () => {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// };

// export default App;



import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import ExamInstructions from "./ExamInstructions";
import ExamQuestion from "./ExamQuestion";
import EndTest from "./EndTest";
import StudentProfile from "./StudentProfile";
import Navbar from "./Components/Navbar";
import LoginPage from "./LoginPage";
import TestReview from "./TestReview";
import ScrollToTop from "./Components/scrolltotop";
import "./App.css";
import PrivateRoute from "./PrivateRoute.jsx";

const AppContent = () => {
  const location = useLocation();

  // Hide navbar for login/root
  const hideNavbarRoutes = ["/login", "/"];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!shouldHideNavbar && <Navbar />}

      <Routes caseSensitive={false}>
        {/* Redirect root to /login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Public: Login page */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected: Profile */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <StudentProfile />
            </PrivateRoute>
          }
        />

        {/* Protected: Exam Instructions */}
        <Route
          path="/ExamInstruction/:attemptId"
          element={
            <PrivateRoute>
              <ExamInstructions />
            </PrivateRoute>
          }
        />

        {/* Protected: Exam Questions */}
        <Route
          path="/ExamQuestion/:attemptId"
          element={
            <PrivateRoute>
              <ExamQuestion />
            </PrivateRoute>
          }
        />

        {/* Protected: End Test */}
        <Route
          path="/EndTest"
          element={
            <PrivateRoute>
              <EndTest />
            </PrivateRoute>
          }
        />

        {/* Protected: Test Review */}
        <Route
          path="/test-review/:attemptId"
          element={
            <PrivateRoute>
              <TestReview />
            </PrivateRoute>
          }
        />

        {/* Catch all unmatched routes */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
